export class DonationInfo {
  cust_name: string = "";
  cust_mobile: string = "";
  cust_email: string = "";
  cust_occupation: string = "";
  fund_code: string = "";
  donation_amount: string = "";
  district: string = "";
  digi_center_name: string = "";
}

export class DonationResponse {
  secure_token: string = "";
  token_exp_time: string = "";
  msg_code: string = "";
  msg_det: string = "";
  ack_tstamp: string = "";
  resp_code: string = "";
  resp_msg: string = "";
  redirect_url: string = ""
}

export class DonationSuccess {
  custName: string = "";
  custMobile: string = "";
  custEmail: string = "";
  custOccupation: string = "";
  donationAmount: string = "";
  district: string = "";
  digiCenterName: string = "";
}



// WEBPACK FOOTER //
// ./src/app/donation/donation-info/donation-request.ts